import { CardGridWrapper, Page, Topbar } from 'components'
import { inject, observer } from 'mobx-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { DataType, UserType } from 'types'
import { PackageForm } from 'views/package/packageSettings'
import { PackageList } from 'views/package/packageList'
import { Pages, RoutingParams } from '../routes'
import { AuthStore, RoutingStore } from '../stores'
import { ParticipantView, MainSidebar } from '../views'
import { useParams } from 'react-router'

export interface IPackageProps {
  authStore?:    AuthStore,
  routingStore?: RoutingStore,
}

/**
 * Shows a list of the programs belonging to the selected package
 *
 * @type Editor, Manager
 */
export const Packages = inject('authStore', 'routingStore')(observer((props: IPackageProps) => {
  const { authStore, routingStore } = props;
  const { t }     = useTranslation();
  const params: RoutingParams = useParams<RoutingParams>();

  let view;
  if(authStore.getCurUserType === UserType.Editor) {
    view = params.id ? 
      <PackageForm />
      : <PackageList />;
  } else {
    view = params.id ? 
        <ParticipantView contentType={DataType.Package} />
      : 
      <CardGridWrapper 
        showSorting
        useCatalog
        contentType   = {DataType.Package}
        title         = {t('packages')}
        desc          = {t('manager_packages_description')}
        onCardClick = {(c) => routingStore.push(Pages.Packages, {id: ""+c.id})}
      />;
  }
    
  return (
    <Page
      sidebar = {<MainSidebar />}
      topbar  = {<Topbar showBackButton={Boolean(params.id)} />}
    >
      {view}
    </Page>
  );
}));
